import React, {useEffect, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from 'react-router-dom';
import {
  useFetchMultiPayment,
  usePath,
  usePaymentsCart,
  usePaymentSettings,
} from '../../../hooks';
import {PATHS} from 'Routes';
import {APP_PAGES} from 'utils/pages';
import {PAYMENT_PROVIDERS} from '@guestapp/sdk';
import Page from '../../../components/Page';
import PaymentForm from '../../../components/PaymentForm';
import {AddonPaymentForm} from 'components/AddonPaymentForm';

function PaymentFormView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const location = useLocation();
  const {paymentProvider} = usePaymentSettings();

  const {paymentsCart, isPaymentsCartLoading} = usePaymentsCart({
    defaultDeferredPayments: location.state?.pay_later_payments,
  });

  const {data: multiPayment, isInitialLoading: isMultiPaymentLoading} =
    useFetchMultiPayment({
      id: location.state?.paymentId,
    });

  const isFromCheckout = location.state?.from === APP_PAGES.checkout;
  const navBarTitle =
    location.state?.from === APP_PAGES.checkout
      ? t('check_out_short')
      : t('booking_payments');

  const onSuccessPaymentForm = useCallback(() => {
    if (isFromCheckout) {
      navigate(location.state?.redirectAfterPaidPath);
    } else {
      navigate(getFullPath(PATHS.payments.ordersHistory));
    }
  }, [isFromCheckout, navigate, location.state?.redirectAfterPaidPath, getFullPath]);

  useEffect(() => {
    if (!location.state?.payments?.length) {
      navigate(getFullPath(PATHS.payments.main));
    }
  }, [getFullPath, location.state?.payments?.length, navigate]);

  useEffect(() => {
    if (
      paymentProvider === PAYMENT_PROVIDERS.addon &&
      !isMultiPaymentLoading &&
      !multiPayment?.id
    ) {
      navigate(getFullPath(PATHS.payments.main));
    }
  }, [getFullPath, isMultiPaymentLoading, multiPayment?.id, navigate, paymentProvider]);

  return (
    <Page
      isSubHeaderVisible
      onBackButtonClick={() => {
        navigate(getFullPath(PATHS.payments.main));
      }}
      hideSubPanelBackButton
      title={t('payment')}
      subtitle={t('enter_your_card_details')}
      navBarTitle={navBarTitle}
      className="payment-form-view"
      isLoading={!paymentProvider}
    >
      {paymentProvider === PAYMENT_PROVIDERS.stripe ? (
        <PaymentForm
          paymentsCart={paymentsCart}
          isLoading={isPaymentsCartLoading}
          onSuccess={onSuccessPaymentForm}
        />
      ) : (
        <AddonPaymentForm
          paymentsCart={paymentsCart}
          isLoading={isPaymentsCartLoading || isMultiPaymentLoading}
          onSuccess={onSuccessPaymentForm}
          multiPayment={multiPayment}
        />
      )}
    </Page>
  );
}

export {PaymentFormView};
